import PropTypes from 'prop-types'
import React from 'react'
import Link, { TARGET_BLANK, TARGET_SELF } from 'components/Link'
import {
  isYoga, isFitness, isVideo, isSeries,
} from 'services/url'
import Button, { TYPES } from 'components/Button'
import IconV2 from 'components/Icon.v2'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import _partial from 'lodash/partial'
import { openWindow } from 'services/share'
import {
  TYPE_CONTENT_VIDEO_YOGA,
  TYPE_CONTENT_VIDEO_FITNESS,
  TYPE_CONTENT_VIDEO_MEDITATION,
  TYPE_CONTENT_EPISODE_YOGA,
  TYPE_CONTENT_EPISODE_FITNESS,
  TYPE_CONTENT_EPISODE_MEDITATION,
  TYPE_CONTENT_SEGMENT_YOGA,
  TYPE_CONTENT_SEGMENT_FITNESS,
  TYPE_CONTENT_SEGMENT_MEDITATION,
  TYPE_CONTENT_SERIES_YOGA,
  TYPE_CONTENT_SERIES_FITNESS,
  TYPE_CONTENT_SERIES_MEDITATION,
  TYPE_CONTENT_SEGMENTED_YOGA,
  TYPE_CONTENT_SEGMENTED_FITNESS,
  TYPE_CONTENT_SEGMENTED_MEDITATION,
} from 'services/content-type'
import { ES, DE, FR } from 'services/languages/constants'
import { getPrimary } from 'services/languages'
import {
  URL_SOCIAL_ICON_FACEBOOK,
  URL_SOCIAL_ICON_FACEBOOK_ES,
  URL_SOCIAL_ICON_FACEBOOK_FR,
  URL_SOCIAL_ICON_FACEBOOK_DE,
  URL_SOCIAL_ICON_FACEBOOK_YOGA,
  URL_SOCIAL_ICON_TWITTER,
  URL_SOCIAL_ICON_TWITTER_YOGA,
  URL_SOCIAL_ICON_INSTAGRAM,
  URL_SOCIAL_ICON_INSTAGRAM_ES,
  URL_SOCIAL_ICON_INSTAGRAM_FR,
  URL_SOCIAL_ICON_INSTAGRAM_DE,
  URL_SOCIAL_ICON_INSTAGRAM_YOGA,
  URL_SOCIAL_ICON_YOUTUBE,
  URL_SOCIAL_ICON_YOUTUBE_ES,
  URL_SOCIAL_ICON_YOUTUBE_FR,
  URL_SOCIAL_ICON_YOUTUBE_DE,
  URL_SOCIAL_ICON_PINTEREST,
  URL_SOCIAL_ICON_PINTEREST_YOGA,
} from 'services/url/constants'

export const SOCIAL_BUTTON_SIZES = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
}

function isYogaContent (contentType, pathname) {
  let yogaContent = false

  if (isYoga(pathname) || isFitness(pathname)) {
    yogaContent = true
  } else if (isVideo(pathname) || isSeries(pathname)) {
    switch (contentType) {
      case TYPE_CONTENT_VIDEO_YOGA:
      case TYPE_CONTENT_VIDEO_FITNESS:
      case TYPE_CONTENT_VIDEO_MEDITATION:
      case TYPE_CONTENT_EPISODE_YOGA:
      case TYPE_CONTENT_EPISODE_FITNESS:
      case TYPE_CONTENT_EPISODE_MEDITATION:
      case TYPE_CONTENT_SEGMENT_YOGA:
      case TYPE_CONTENT_SEGMENT_FITNESS:
      case TYPE_CONTENT_SEGMENT_MEDITATION:
      case TYPE_CONTENT_SERIES_YOGA:
      case TYPE_CONTENT_SERIES_FITNESS:
      case TYPE_CONTENT_SERIES_MEDITATION:
      case TYPE_CONTENT_SEGMENTED_YOGA:
      case TYPE_CONTENT_SEGMENTED_FITNESS:
      case TYPE_CONTENT_SEGMENTED_MEDITATION:
        yogaContent = true
        break
      default:
        yogaContent = false
    }
  } else {
    yogaContent = false
  }

  return yogaContent
}

function getFacebookUrl (contentType, pathName, language) {
  switch (language) {
    case DE:
      return URL_SOCIAL_ICON_FACEBOOK_DE
    case ES:
      return URL_SOCIAL_ICON_FACEBOOK_ES
    case FR:
      return URL_SOCIAL_ICON_FACEBOOK_FR
    default:
      return isYogaContent(
        contentType,
        pathName,
      )
        ? URL_SOCIAL_ICON_FACEBOOK_YOGA
        : URL_SOCIAL_ICON_FACEBOOK
  }
}

function getTwitterUrl (contentType, pathName, language) {
  switch (language) {
    case DE:
    case ES:
    case FR:
      return null
    default:
      return isYogaContent(
        contentType,
        pathName,
      )
        ? URL_SOCIAL_ICON_TWITTER_YOGA
        : URL_SOCIAL_ICON_TWITTER
  }
}

function getInstagramUrl (contentType, pathName, language) {
  switch (language) {
    case DE:
      return URL_SOCIAL_ICON_INSTAGRAM_DE
    case ES:
      return URL_SOCIAL_ICON_INSTAGRAM_ES
    case FR:
      return URL_SOCIAL_ICON_INSTAGRAM_FR
    default:
      return isYogaContent(
        contentType,
        pathName,
      )
        ? URL_SOCIAL_ICON_INSTAGRAM_YOGA
        : URL_SOCIAL_ICON_INSTAGRAM
  }
}

function getYoutubeUrl (language) {
  switch (language) {
    case DE:
      return URL_SOCIAL_ICON_YOUTUBE_DE
    case ES:
      return URL_SOCIAL_ICON_YOUTUBE_ES
    case FR:
      return URL_SOCIAL_ICON_YOUTUBE_FR
    default:
      return URL_SOCIAL_ICON_YOUTUBE
  }
}

function getPinterestUrl (contentType, pathName, language) {
  switch (language) {
    case DE:
    case ES:
    case FR:
      return null
    default:
      return isYogaContent(
        contentType,
        pathName,
      )
        ? URL_SOCIAL_ICON_PINTEREST_YOGA
        : URL_SOCIAL_ICON_PINTEREST
  }
}

function getUrlWithType (type, contentType, pathName, language) {
  switch (type) {
    case SOCIAL_BUTTON_TYPES.FACEBOOK:
      return getFacebookUrl(contentType, pathName, language)
    case SOCIAL_BUTTON_TYPES.TWITTER:
      return getTwitterUrl(contentType, pathName, language)
    case SOCIAL_BUTTON_TYPES.INSTAGRAM:
      return getInstagramUrl(contentType, pathName, language)
    case SOCIAL_BUTTON_TYPES.YOUTUBE:
      return getYoutubeUrl(language)
    case SOCIAL_BUTTON_TYPES.PINTEREST:
      return getPinterestUrl(contentType, pathName, language)
    default:
      return null
  }
}

function getClass (size, type) {
  return size === 'large' // || size === 'small'
    ? `social-button--${size} social-button__${type}`
    : `social-button--${size}`
}

export const eventTypeTwitter = 'Twitter'
export const eventTypeFacbook = 'Facebook'

export const SOCIAL_BUTTON_TYPES = {
  EMBED: 'embed',
  EMAIL: 'email',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  REDDIT: 'reddit',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  PINTEREST: 'pinterest',
  WEBSITE: 'website',
}

function socialButtonOnClick (e, props) {
  const {
    openShareWindow,
    onClick,
    url,
  } = props

  if (onClick) {
    e.preventDefault()
    onClick(e)
  }

  if (url) {
    openWindow(e, openShareWindow, url)
  }
}

function SocialButton (props) {
  const {
    size, type, target, onClick, contentType, pathName, to, user,
  } = props
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const urlWithType = getUrlWithType(type, contentType, pathName, userLanguage)
  const url = onClick ? null : to || urlWithType

  if (url) {
    return (
      <Link
        role="link"
        to={url}
        target={target === TARGET_SELF ? null : target}
        onClick={!onClick ? _partial(socialButtonOnClick, _partial.placeholder, props) : onClick}
        className="social-button"
      >
        <span className={getClass(size, type)}>
          <IconV2 type={type} />
        </span>
        <span className="assistive">{type}</span>
      </Link>
    )
  } if (onClick) {
    return (
      <Button
        type={TYPES.LINK}
        onClick={!onClick ? _partial(socialButtonOnClick, _partial.placeholder, props) : onClick}
        className="social-button"
      >
        <span className={getClass(size, type)}>
          <IconV2 type={type} />
        </span>
        <span className="assistive">{type}</span>
      </Button>
    )
  }

  return (null)
}

SocialButton.defaultProps = {
  target: TARGET_BLANK,
}

SocialButton.propTypes = {
  eventTrackingType: PropTypes.string,
  auth: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf([
    SOCIAL_BUTTON_SIZES.XSMALL,
    SOCIAL_BUTTON_SIZES.SMALL,
    SOCIAL_BUTTON_SIZES.MEDIUM,
    SOCIAL_BUTTON_SIZES.LARGE,
  ]),
  contentType: PropTypes.string,
  pathName: PropTypes.string,
  to: PropTypes.string,
  target: PropTypes.oneOf([
    TARGET_BLANK,
    TARGET_SELF,
  ]),
}

const memoizedButton = React.memo(SocialButton)

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
    }),
  ),
)(memoizedButton)
